module.exports = __webpack_public_path__ + "img/c2_m.3db0666a.png";